import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "chat-export"
};
const _hoisted_2 = {
  class: "chat-box",
  id: "chat-box"
};
const _hoisted_3 = {
  class: "title pt-4"
};
import ChatReply from "@/components/ChatReply.vue";
import ChatPrompt from "@/components/ChatPrompt.vue";
import { nextTick, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { httpGet } from "@/utils/http";
import "highlight.js/styles/a11y-dark.css";
import hl from "highlight.js";
import { ElMessage } from "element-plus";
import Clipboard from "clipboard";
export default {
  __name: 'ChatExport',
  setup(__props) {
    const chatData = ref([]);
    const router = useRouter();
    const chatId = router.currentRoute.value.query["chat_id"];
    const loading = ref(true);
    const chatTitle = ref("");
    httpGet("/chat/history?chat_id=" + chatId).then(res => {
      const data = res.data;
      if (!data) {
        loading.value = false;
        return;
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].type === "prompt") {
          chatData.value.push(data[i]);
          continue;
        } else if (data[i].type === "mj") {
          data[i].content = JSON.parse(data[i].content);
          data[i].content.content = data[i].content?.content;
          chatData.value.push(data[i]);
          continue;
        }
        data[i].orgContent = data[i].content;
        data[i].content = data[i].content;
        chatData.value.push(data[i]);
      }
      nextTick(() => {
        hl.configure({
          ignoreUnescapedHTML: true
        });
        const blocks = document.querySelector("#chat-box").querySelectorAll("pre code");
        blocks.forEach(block => {
          hl.highlightElement(block);
        });
      });
      loading.value = false;
    }).catch(e => {
      ElMessage.error("加载聊天记录失败：" + e.message);
    });
    httpGet("/chat/detail?chat_id=" + chatId).then(res => {
      chatTitle.value = res.data.title;
    }).catch(e => {
      ElMessage.error("加载会失败： " + e.message);
    });
    onMounted(() => {
      const clipboard = new Clipboard(".copy-reply");
      clipboard.on("success", () => {
        ElMessage.success("复制成功！");
      });
      clipboard.on("error", () => {
        ElMessage.error("复制失败！");
      });
    });
    return (_ctx, _cache) => {
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h2", null, _toDisplayString(chatTitle.value), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatData.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id
        }, [item.type === 'prompt' ? (_openBlock(), _createBlock(ChatPrompt, {
          key: 0,
          data: item,
          "list-style": "list"
        }, null, 8, ["data"])) : item.type === 'reply' ? (_openBlock(), _createBlock(ChatReply, {
          key: 1,
          data: item,
          "read-only": true,
          "list-style": "list"
        }, null, 8, ["data"])) : _createCommentVNode("", true)]);
      }), 128))])])), [[_directive_loading, loading.value]]);
    };
  }
};